import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FormProvider } from "react-hook-form";

import { useCoiContext } from "../contexts/Coi";
import useCOIHandlers from "../hooks/useCOIHandlers";

import FileUpload from "../../../../../components/FileUpload";
import { VALID_FILE_EXTENSIONS } from "../../../../../lib/globals";
import { displayFormAlert } from "../../../../../lib/utils";

const COIForm = () => {
    const { methods, fileList, setFileList } = useCoiContext();
    const { onSubmit } = useCOIHandlers();
    const allowedExtensions = VALID_FILE_EXTENSIONS.file.slice();

    return (
        <FormProvider {...methods}>
            <Form
                onSubmit={methods.handleSubmit(onSubmit)}
                id="clubhouseTeamCOIForm"
                data-testid="clubhouseTeamCOIForm"
            >
                <Row>
                    <Col>
                        <Form.Label>Certificate of Insurance</Form.Label>
                        <Form.Group controlId="files">
                            <FileUpload
                                maxFileCount={1}
                                allowedFileExtensions={allowedExtensions}
                                maxFileSize={5120000}
                                fileList={fileList}
                                setFileList={setFileList}
                            />
                            <Form.Label className="small">
                                Accepted file types:{" "}
                                {allowedExtensions.join(", ")}
                                <br />
                                Max file size: 5 MB
                            </Form.Label>
                        </Form.Group>
                        {methods.formState.errors.files &&
                            displayFormAlert({
                                level: "danger",
                                text: methods.formState.errors.files
                                    .message as string,
                            })}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button variant="primary" type="submit">
                            Upload
                        </Button>
                    </Col>
                </Row>
            </Form>
        </FormProvider>
    );
};

export default COIForm;
